import { motion } from 'framer-motion';
import styled from 'styled-components';

const FadeInWrapper = styled(motion.div)`
  width: 100%;
`;

interface FadeInContentProps {
  children: React.ReactNode;
  delay?: number;
}

/**
 * Componente que adiciona animação de fade-in suave ao conteúdo
 * Usado para transição suave após skeleton loader
 */
export const FadeInContent: React.FC<FadeInContentProps> = ({ children, delay = 0 }) => {
  return (
    <FadeInWrapper
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.4,
        delay,
        ease: [0.22, 1, 0.36, 1], // ease-out suave
      }}
    >
      {children}
    </FadeInWrapper>
  );
};

export default FadeInContent;
